import { createStructuredSelector } from "reselect";
import {
    IDX_RPT_QUALITY_REPORT,
    IDX_RPT_QUALITY_REPORT_SUCCESS,
    IDX_RPT_QUALITY_REPORT_ERROR,
    IDX_RPT_QUALITY_SUPPLIER,
    IDX_RPT_QUALITY_SUPPLIER_SUCCESS,
    IDX_RPT_QUALITY_SUPPLIER_ERROR,
    IDX_RPT_QUALITY_PRODUCT,
    IDX_RPT_QUALITY_PRODUCT_SUCCESS,
    IDX_RPT_QUALITY_PRODUCT_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MED,
    IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS,
    IDX_RPT_QUALITY_MTX_QA_MED_ERROR,
    IDX_RPT_QUALITY_SEARCH_CHANGE,
    IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET,
    IDX_RPT_QUALITY_SUPPLIER_MMQ,
    IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS,
    IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR,
    IDX_RPT_QUALITY_PRODUCT_MMQ,
    IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS,
    IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MMQ,
    IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS,
    IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE,
    IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET
} from "../../actions";

export const NAME = 'idxRptQuality';


export const IdxRptQualityReport = (data) => ({
    type: IDX_RPT_QUALITY_REPORT,
    payload: data
});

export const IdxRptQualityReportSuccess = (data) => ({
    type: IDX_RPT_QUALITY_REPORT_SUCCESS,
    payload: data
});

export const IdxRptQualityReportError = (error) => ({
    type: IDX_RPT_QUALITY_REPORT_ERROR,
    payload: error
});

export const IdxRptQualitySupplier = (data) => ({
    type: IDX_RPT_QUALITY_SUPPLIER,
    payload: data
});

export const IdxRptQualitySupplierSuccess = (data) => ({
    type: IDX_RPT_QUALITY_SUPPLIER_SUCCESS,
    payload: data
});

export const IdxRptQualitySupplierError = (error) => ({
    type: IDX_RPT_QUALITY_SUPPLIER_ERROR,
    payload: error
});

export const IdxRptQualityProduct = (data) => ({
    type: IDX_RPT_QUALITY_PRODUCT,
    payload: data
});

export const IdxRptQualityProductSuccess = (data) => ({
    type: IDX_RPT_QUALITY_PRODUCT_SUCCESS,
    payload: data
});

export const IdxRptQualityProductError = (error) => ({
    type: IDX_RPT_QUALITY_PRODUCT_ERROR,
    payload: error
});

export const IdxRptQualityMtxQAMed = (page, num_page, orderBy, filters, stateFilter) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MED,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const IdxRptQualityMtxQAMedSuccess = (data) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS,
    payload: data
});

export const IdxRptQualityMtxQAMedError = (error) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MED_ERROR,
    payload: error
});

export const IdxRptQualitySearchChange = (data) => ({
    type: IDX_RPT_QUALITY_SEARCH_CHANGE,
    payload: data
});

export const IdxRptQualityMtxQAMedPageSet = (data) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET,
    payload: data
});

export const IdxRptQualitySupplierMmq = (data) => ({
    type: IDX_RPT_QUALITY_SUPPLIER_MMQ,
    payload: data
});

export const IdxRptQualitySupplierMmqSuccess = (data) => ({
    type: IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS,
    payload: data
});

export const IdxRptQualitySupplierMmqError = (error) => ({
    type: IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR,
    payload: error
});

export const IdxRptQualityProductMmq = (data) => ({
    type: IDX_RPT_QUALITY_PRODUCT_MMQ,
    payload: data
});

export const IdxRptQualityProductMmqSuccess = (data) => ({
    type: IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS,
    payload: data
});

export const IdxRptQualityProductMmqError = (error) => ({
    type: IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR,
    payload: error
});

export const IdxRptQualityMtxQAMmq = (page, num_page, orderBy, filters, stateFilter) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MMQ,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const IdxRptQualityMtxQAMmqSuccess = (data) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS,
    payload: data
});

export const IdxRptQualityMtxQAMmqError = (error) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR,
    payload: error
});

export const IdxRptQualityMtxQAMmqSearchChange = (data) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE,
    payload: data
});

export const IdxRptQualityMtxQAMmqPageSet = (data) => ({
    type: IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET,
    payload: data
});

const idxRptQuality = (state) => state[NAME];

export const IdxRptQualitySelector = createStructuredSelector({
    idxRptQuality
})